import * as actionTypes from "./actionTypes";
import { initialStore } from "./initialStore";

export function vesselVesselReducer(state = initialStore, action = {}) {
  switch (action.type) {
    case actionTypes.SET_CALCULATOR_DATA:
      return {
        ...state,
        calculatorData: action.payload,
      };

    case actionTypes.SET_SELECTED_VESSELS:
      return {
        ...state,
        selectedVessels: action.payload,
      };

    case actionTypes.SET_PORT_OPERATIONS:
      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          portOperation: action.payload,
        },
      };

    case actionTypes.SET_FLEET_LIST:
      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          fleetList: action.payload,
        },
      };

    case actionTypes.SET_SELECTED_QUERY:
      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          clientQuery: action.payload,
        },
      };

    case actionTypes.SET_SYNC_BUNKER:
      return {
        ...state,
        syncBunker: action.payload,
      };

    case actionTypes.SET_IS_OVERRIDE:
      return {
        ...state,
        isOverride: action.payload,
      };

    case actionTypes.SET_ESTIMATION_EST_ID:
      return {
        ...state,
        estimationEstId: action.payload,
      };

    case actionTypes.SET_SPLIT_HIRE_ARRAY:
      return {
        ...state,
        splitHireArray: action.payload,
      };

    case actionTypes.SET_PORT_DISTANCE_RESPONSE:
      return {
        ...state,
        portDistanceResponse: action.payload,
      };

    case actionTypes.SET_REAL_PORT_DISTANCE_RESPONSE:
      return {
        ...state,
        realPortDistanceResponse: action.payload,
      };

    case actionTypes.SET_PORT_DISTANCE_PAYLOAD_RESPONSE:
      return {
        ...state,
        portDistancePayloadResponse: action.payload,
      };

    case actionTypes.RESET_STORE:
      return {
        ...initialStore,
      };

    default:
      return state;
  }
}
